

import React  from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from "react-router";

import Layout from '../components/layouts/blank-page.js';
import SingleInput from '../components/inputs/single.input.js';

export default class LoginComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {email:'', loaded:true}
    }

    handleEmailChange(e) {
        this.setState({ email: e.target.value });
    }


    handleSubmit(event) {
       // UserAuthentication.authenticate(this.state.username , this.state.password);
    }


    render(){
        return (<Layout><div className="login" >
            <div className={"l-block animate toggled"} id="l-login">
                <div className="lb-header palette-Languagenut bg">
                    <center><img src="img/logos/languagenut/no-text-logo.png"/></center>
                    <center><h1 className="palette-Branding primary text"><FormattedMessage id={ 'ui-26' } defaultMessage={ 'Reset Password' }/></h1></center>
                </div>
                <div className="lb-body">
                    <div className="form-group fg-float">
                        <div className="fg-line">
                            <SingleInput
                                inputType={'text'}
                                toggled={false}
                                content={this.state.email}
                                labelTranslationUID='ui-9'
                                labelName='Email'
                                controlFunc={this.handleEmailChange.bind(this)}/>
                        </div>
                    </div>
                    <button onClick={this.handleSubmit.bind(this)} className="palette-Yellow btn btn-primary btn-lg btn-block" ><FormattedMessage id={ 'ui-254' } defaultMessage={ 'Request Reset' }/></button>
                    <Link to="/" className="palette-White text palette-Branding Green btn btn-primary btn-lg btn-block" ><FormattedMessage id={ 'ui-13' } defaultMessage={ 'Login' }/></Link>

                </div>
            </div>
        </div></Layout>)
    }
}


// WEBPACK FOOTER //
// ./src/screens/forgotten-password.js